import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_x2E1ay0Bxgg0: {
	id: 'prd_x2E1a2DEV2y0Bxgg0'
	ident: 'prd_x2E1ay0Bxgg0'
	sku: 'simple_premium_1w_6_93_4w_38_95_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_RpOjF2DEV2a05AjRh'
			amount: 17.77
			amount_usd: 6.93
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 6.93
			discount: 10.84
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_BCkTu2DEV2SQEwQya'
			amount: 38.95
			amount_usd: 38.95
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_x2E1ay0Bxgg0, SubscriptionProduct>
const prd_x2E1ay0Bxgg0 = { ident: 'prd_x2E1ay0Bxgg0' } as typeof _prd_x2E1ay0Bxgg0

export default prd_x2E1ay0Bxgg0
